<template>
    <div class="w-full bg-green-200 main_transfer_form 
        xl:border-round-3xl
        xl:border-ios-2xl">
        <div class="flex w-full justify-content-center align-items-center 
            p-0 xl:py-6 lg:py-6 md:py-6 sm:py-6">
            <div class="flex flex-column w-full surface-0 pl-3 pr-3 pt-0 pb-0 pb-5 xl:p-6 lg:p-6 md:p-4 sm:pl-3 sm:pr-3 sm:pt-4 sm:pb-4 xl:border-round-3xl lg:border-round-2xl md:border-round-2xl sm:border-round-2xl"
            style="max-width: 560px;">
                <TransferFilter :currency_receive_first="(currency_receive_first) ? currency_receive_first : 'idr'" />
            </div>
        </div>
    </div>
</template>

<script>
import TransferFilter from '@/components/widgets/TransferFilter.vue' 

export default {
    props: ['currency_receive_first'],
    data() {
        return {
            filter: null,
            active_index: 0,
            isTransferError: false,
            errorMessage: '',
            tabs: [
                {
                    "en": "Any",
                    "ru": "Любой",
                    "codes": null,
                    "disabled": false,
                    "index": 0
                },
                {
                    "en": "Online",
                    "ru": "Отправить онлайн",
                    "codes": ["card", "stock", "sbp", "swift"],
                    "disabled": false,
                    "index": 1
                },
                {
                    "en": "Сash",
                    "ru": "Получить наличные",
                    "codes": ["atm", "office", "courier"],
                    "disabled": false,
                    "index": 2
                },
                {
                    "en": "Request",
                    "ru": "Под запрос",
                    "codes": ["request"],
                    "disabled": false,
                    "index": 3
                }
            ],
        }
    },
    computed: {
        lang_() {
            return (this.$i18n.locale) ? this.$i18n.locale : 'en'
        }
    },
    methods: {
        transferError(error) {
            this.isTransferError = error
            if(error) {
                this.tabs[0].disabled = true
                this.tabs[1].disabled = true
                this.tabs[2].disabled = true
                this.active_index = 3
            }
        },
        setErrorMessage(message) {
            this.errorMessage = message
        },
        setFilter(index) {
            if(this.tabs[index].disabled) return
            this.filter = (this.tabs[index].codes) ? this.tabs[index].codes : null
            if(this.tabs[index].codes) this.active_index = index
            else this.active_index = 0
        }
    },
    components: {
        TransferFilter
    }
}
</script>
